var _rect, _path, _path2, _g, _ellipse, _ellipse2, _ellipse3, _ellipse4, _circle, _circle2, _circle3, _circle4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 49,
    viewBox: "0 0 57 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_250_3656",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 49
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 48.5406,
    rx: 18.7314,
    transform: "matrix(-1 0 0 1 57 0)",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_250_3656)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5424 5.48368C57.5088 15.2747 52.1087 56.1872 52.1087 56.1872L50.5563 62.1147L42.4589 66.7543L10.5811 66.3838L7.14004 63.1562L6.751 59.5379C10.5439 56.4506 -0.547014 19.6825 11.9254 7.17473C18.2991 0.783005 36.1628 -0.426126 44.5424 5.48368Z",
    fill: "#FDDB44"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_250_3656",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 1,
    width: 49,
    height: 66
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5424 5.48369C57.5088 15.2747 52.1087 56.1872 52.1087 56.1872L50.5563 62.1147L42.4589 66.7543L10.5811 66.3838L6.24033 63.1033L6.89581 57.1374C10.6887 54.0502 -0.547014 19.6825 11.9254 7.17474C18.2991 0.783009 36.1628 -0.426122 44.5424 5.48369Z",
    fill: "#FDDB44"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_250_3656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8231 6.29817C24.3403 0.970493 31.9966 -1.28759 31.9966 -1.28759L23.5288 -5.69792L6.91069 10.779L2.37683 46.9261L7.13998 63.1561L16.7545 73.6527L48.0854 73.0882L55.6007 62.9974L53.8366 36.7118C53.8366 36.7118 51.649 43.2038 47.4151 43.5566C43.1812 43.9095 25.8927 46.2028 23.0525 43.3273C20.2122 40.4518 21.306 11.6258 22.8231 6.29817Z",
    fill: "#FCB537"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.41178,
    cy: 9.01669,
    rx: 8.41178,
    ry: 9.01669,
    transform: "matrix(-0.998274 -0.058723 -0.058723 0.998274 53.7113 13.2668)",
    fill: "#CBBED8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.2101,
    cy: 7.51052,
    rx: 7.2101,
    ry: 7.51052,
    transform: "matrix(-0.998274 -0.058723 -0.058723 0.998274 51.1729 15.4895)",
    fill: "#FDFEF9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.7122,
    cy: 9.31304,
    rx: 8.7122,
    ry: 9.31304,
    transform: "matrix(-0.998274 -0.058723 -0.058723 0.998274 34.4491 13.3019)",
    fill: "#CBBED8"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.81094,
    cy: 8.11136,
    rx: 7.81094,
    ry: 8.11136,
    transform: "matrix(-0.998274 -0.058723 -0.058723 0.998274 32.5087 15.5953)",
    fill: "#FDFEF9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.80673,
    cy: 4.80673,
    r: 4.80673,
    transform: "matrix(-0.998274 -0.058723 -0.058723 0.998274 47.9976 18.3121)",
    fill: "#0D071D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.80673,
    cy: 4.80673,
    r: 4.80673,
    transform: "matrix(-0.998274 -0.058723 -0.058723 0.998274 30.5326 18.4885)",
    fill: "#0D071D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.20168,
    cy: 1.20168,
    r: 1.20168,
    transform: "matrix(-0.998274 -0.058723 -0.058723 0.998274 45.5278 19.3706)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.20168,
    cy: 1.20168,
    r: 1.20168,
    transform: "matrix(-0.998274 -0.058723 -0.058723 0.998274 28.6274 20.182)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7758 25.2275C43.5945 25.2219 44.3697 24.3641 44.8436 23.7075C45.1082 23.3409 45.6407 23.2441 45.9859 23.5361C46.2588 23.767 46.3172 24.1626 46.099 24.4457C45.4663 25.2671 44.0954 26.7933 42.6876 26.727C41.1884 26.6564 40.0596 24.8062 39.6832 24.1023C39.5956 23.9385 39.6172 23.7414 39.7291 23.5932C39.95 23.3007 40.408 23.3286 40.6202 23.6274C41.0951 24.2961 41.9148 25.2334 42.7758 25.2275Z",
    fill: "url(#paint0_linear_250_3656)",
    stroke: "black",
    strokeWidth: 0.50499
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2932 25.7037C26.0948 25.6982 26.8484 24.9851 27.3195 24.421C27.6025 24.0822 28.1197 24.0026 28.4567 24.2877C28.7427 24.5297 28.7937 24.9488 28.548 25.2315C27.8986 25.9789 26.5738 27.2677 25.205 27.2032C23.733 27.1339 22.6069 25.5382 22.2061 24.885C22.1042 24.7189 22.122 24.5109 22.2394 24.3554L22.2621 24.3253C22.4742 24.0444 22.9089 24.0562 23.1338 24.327C23.6151 24.9064 24.4374 25.7096 25.2932 25.7037Z",
    fill: "url(#paint1_linear_250_3656)",
    stroke: "black",
    strokeWidth: 0.50499
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7822 38.6525C34.444 41.5699 30.898 41.3962 24.5875 37.6999",
    stroke: "black",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7988 29.7231C38.6623 35.6683 46.2795 36.8391 51.4904 30.5551C42.6646 32.6377 39.6179 30.9424 35.8426 25.4215C35.8426 25.4215 30.5326 33.8364 23.4055 32.2134C16.2784 30.5904 15.9785 25.4568 15.9785 25.4568L12.9795 25.2803C12.9795 25.2803 12.8678 25.8745 15.1993 30.3758C17.5309 34.8772 27.7423 37.1325 34.7988 29.7231Z",
    fill: "#F9A831"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74561 20.5172L15.22 17.8886L16.2432 26.0742L9.5571 27.1856L8.74561 20.5172Z",
    fill: "#13152C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3827 11.5987C40.1795 11.2928 35.5834 15.5106 35.2503 21.1735C34.9172 26.8365 38.9871 31.5641 44.1903 31.8703C49.3936 32.1764 53.9896 27.9585 54.3228 22.2955C54.6559 16.6324 50.5861 11.9048 45.3827 11.5987Z",
    stroke: "url(#paint2_linear_250_3656)",
    strokeWidth: 2.52495
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8191 11.6517C20.4182 11.3339 15.7175 15.579 15.3863 21.2088C15.0552 26.8387 19.2257 31.6055 24.6266 31.9232C30.0273 32.2408 34.7272 27.9957 35.0584 22.366C35.3895 16.7363 31.2197 11.9695 25.8191 11.6517Z",
    stroke: "url(#paint3_linear_250_3656)",
    strokeWidth: 2.52495
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.648312 25.1568C0.75615 22.4301 1.33633 18.5766 4.03545 18.7354C6.73457 18.8942 6.34646 20.3761 6.34646 20.3761L7.06975 28.544C7.06975 28.544 4.75873 32.0193 3.27686 31.6312C1.79499 31.2431 0.544641 27.7782 0.648312 25.1568Z",
    fill: "#FAFBF6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10479 17.7122C4.88534 17.6531 3.7353 18.7178 3.7353 18.7178C3.7353 18.7178 5.71113 20.9406 5.76404 25.1569C5.83189 30.564 3.27661 31.6312 3.27661 31.6312C3.27661 31.6312 4.31637 32.1761 5.04074 32.3369C6.1918 32.5924 8.05741 32.2134 8.05741 32.2134C8.05741 32.2134 10.5272 31.1549 9.99796 24.804C9.46873 18.4532 7.10479 17.7122 7.10479 17.7122Z",
    fill: "#252644"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61398 25.3313C3.64926 24.7315 3.26116 21.0974 2.36145 21.0445C1.46175 20.9916 1.28532 23.9906 1.23241 24.8903C1.17949 25.79 1.30297 28.8067 2.50258 28.8772C3.55033 28.9389 3.58877 26.6454 3.60521 25.6641C3.6076 25.5219 3.60952 25.4073 3.61398 25.3313Z",
    fill: "#2F3451"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.159 30.9169L51.7523 46.5676L53.339 45.1735L53.0724 29.0035L51.159 30.9169Z",
    fill: "#FFEEA1",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84025 32.4428L8.25792 47.2314L6.84804 46.1237L5.64064 32.3722L6.84025 32.4428Z",
    fill: "#FFEEA1",
    style: {
      mixBlendMode: "color-dodge"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_250_3656",
    x1: 39.5033,
    y1: 24.5836,
    x2: 46.4011,
    y2: 24.9894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#2778DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C0522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_250_3656",
    x1: 22.0031,
    y1: 25.3598,
    x2: 28.9008,
    y2: 25.7655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#2778DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C0522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_250_3656",
    x1: 45.4572,
    y1: 10.3382,
    x2: 44.1164,
    y2: 33.1308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#323D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_250_3656",
    x1: 25.8929,
    y1: 10.3911,
    x2: 24.5521,
    y2: 33.1837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#323D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon);
export default __webpack_public_path__ + "static/media/nav-icon.48c03b324a3a113263a95a47eee25e95.svg";
export { ForwardRef as ReactComponent };